"use client";
function c(t, r, n) {
  try {
    const e = new URL(t);
    return e.searchParams.set(n, r), e.toString();
  } catch {
    return t;
  }
}
export {
  c as getUrlWithQuery
};
